import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Payment Dialogs (no dedicated pages, dialogs are opened from other modules)
import { PaymentUserWarningComponent } from '../../dialog/payment-user-warning/payment-user-warning.component';
import { EditSubscriptionComponent } from '../../dialog/edit-subscription/edit-subscription.component';
import { CancelSubscriptionComponent } from '../../dialog/cancel-subscription/cancel-subscription.component';
import { ChangePlanComponent } from '../../dialog/change-plan/change-plan.component';
import { ConfirmPlanChangeComponent } from '../../dialog/confirm-plan-change/confirm-plan-change.component';

@NgModule({
  declarations: [
    PaymentUserWarningComponent,
    EditSubscriptionComponent,
    CancelSubscriptionComponent,
    ChangePlanComponent,
    ConfirmPlanChangeComponent,
  ],
  imports: [
    SharedModule,
  ],
  exports: [
    // Export dialogs so they can be opened from other modules
    PaymentUserWarningComponent,
    EditSubscriptionComponent,
    CancelSubscriptionComponent,
    ChangePlanComponent,
    ConfirmPlanChangeComponent,
  ],
})
export class PaymentModule {}
